var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"color":_vm.toolbarColor,"dense":"","elevation":"0","dark":""}},[_c('v-icon',{attrs:{"left":"","color":"white"}},[_vm._v("mdi-handshake")]),_c('v-toolbar-title',[_vm._v("Pairing & Placement")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }